export const areas = {
    manageRent: 'manage-rent',
    post: 'post-area',
    renter:"renter-area",
    admin:"admin"
  };
  